import React from 'react';
import { motion } from 'framer-motion';
import { PlaySquare } from 'lucide-react';
const videos = ['https://cdn.magicpatterns.com/uploads/7hwayoDB1MQ4XGE8iqferv/AQOZdZSus4Mf2anzBzSpuh-tY0UC_HItC1t-86HxWWBqN-WysfC62OagP7AX3twVssjs13_swgggQapHsAwg0Hgq.mp4', 'https://cdn.magicpatterns.com/uploads/uDPynSg2QFLs8veStpfJAR/AQOcnOi5UgWsUhX1-YJVr2qzgxv9Tesj0gbTCPIaOUcvWVJ9R4yq6zypxBtIj4zjQJV1HHsFPrX_z-rVicCJpdSl.mp4', 'https://cdn.magicpatterns.com/uploads/hrUmZAm1J38m7yYgvJCWNU/AQMRUpXd5EwOWg_VDnPd4hhBo3VGhOzIv6VQ6ohpviZBpqyRIdYV30YejnQnVb3WdRHRcWekM7JYUq2bGiL_Vnm3.mp4', 'https://cdn.magicpatterns.com/uploads/fWyPWdJcygvqte1Gunrq2e/From KlickPin CF tessa suprata photography on Instagram GRANT X RANSOM X NIGHT VISION VHS 🧪 i now offer vhs shoots in color and night vision!! 🤭     photography photog… [Video] [Video] _ Learn photo editing Filmmaking ins.mp4', 'https://cdn.magicpatterns.com/uploads/6yMXJvBAuUfXwRN4VAqh34/From KlickPin CF Pin by RESOURCE on Motion graphic _ Photo editing techniques Filmmaking inspiration Photo editing tricks.mp4', 'https://cdn.magicpatterns.com/uploads/kzysi8uWB9JQCAmQ6EF4Vi/From KlickPin CF 50 Years of Hip Hop Social Post.mp4', 'https://cdn.magicpatterns.com/uploads/cFJarrSJzhHTGrV2U5ZNTn/From KlickPin CF Performance isn’t created it’s engineered an edit for porsche _ Motion design Motion graphics tutorial Motion graphics inspiration.mp4', 'https://cdn.magicpatterns.com/uploads/4y1fodZFDKgXHJ6dyhVK11/From KlickPin CF Motion Graphics [Video] _ Video editing software Motion Motion graphics.mp4'];
export function VideoShowcase() {
  return <section className="py-16 px-4 md:px-8 max-w-7xl mx-auto" data-id="element-190">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="flex flex-col items-center mb-12" data-id="element-191">
        <div className="flex items-center space-x-3 mb-4" data-id="element-192">
          <PlaySquare className="w-6 h-6 text-primary" data-id="element-193" />
          <h2 className="text-xl md:text-2xl font-black uppercase tracking-widest text-center" data-id="element-194">
            VIDEOS LOGRABLES CON EL PACK
          </h2>
        </div>
        <div className="w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent" data-id="element-195"></div>
      </motion.div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-196">
        {videos.map((src, index) => <motion.div key={index} initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} viewport={{
        once: true
      }} className="relative rounded-xl overflow-hidden glow-border aspect-[9/16] bg-surface group" data-id="element-197">
            <video src={src} autoPlay loop muted playsInline className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity duration-300" data-id="element-198" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent pointer-events-none" data-id="element-199"></div>
          </motion.div>)}
      </div>
    </section>;
}